/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderStatusStatisticsVo } from './OrderStatusStatisticsVo';
import {
    OrderStatusStatisticsVoFromJSON,
    OrderStatusStatisticsVoFromJSONTyped,
    OrderStatusStatisticsVoToJSON,
    OrderStatusStatisticsVoToJSONTyped,
} from './OrderStatusStatisticsVo';

/**
 * 
 * @export
 * @interface OrderStatusGroupVo
 */
export interface OrderStatusGroupVo {
    /**
     * 订单状态组名称 韩文
     * @type {string}
     * @memberof OrderStatusGroupVo
     */
    nameKr?: string;
    /**
     * 订单状态组名称 中文
     * @type {string}
     * @memberof OrderStatusGroupVo
     */
    nameCn?: string;
    /**
     * 订单状态组编码
     * @type {number}
     * @memberof OrderStatusGroupVo
     */
    statusGroupCode?: number;
    /**
     * 订单状态组下的订单状态统计列表
     * @type {Array<OrderStatusStatisticsVo>}
     * @memberof OrderStatusGroupVo
     */
    children?: Array<OrderStatusStatisticsVo>;
}

/**
 * Check if a given object implements the OrderStatusGroupVo interface.
 */
export function instanceOfOrderStatusGroupVo(value: object): value is OrderStatusGroupVo {
    return true;
}

export function OrderStatusGroupVoFromJSON(json: any): OrderStatusGroupVo {
    return OrderStatusGroupVoFromJSONTyped(json, false);
}

export function OrderStatusGroupVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderStatusGroupVo {
    if (json == null) {
        return json;
    }
    return {
        
        'nameKr': json['nameKr'] == null ? undefined : json['nameKr'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
        'statusGroupCode': json['statusGroupCode'] == null ? undefined : json['statusGroupCode'],
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(OrderStatusStatisticsVoFromJSON)),
    };
}

export function OrderStatusGroupVoToJSON(json: any): OrderStatusGroupVo {
    return OrderStatusGroupVoToJSONTyped(json, false);
}

export function OrderStatusGroupVoToJSONTyped(value?: OrderStatusGroupVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nameKr': value['nameKr'],
        'nameCn': value['nameCn'],
        'statusGroupCode': value['statusGroupCode'],
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(OrderStatusStatisticsVoToJSON)),
    };
}

